require('jquery');

export class SplitPane
{
	static main;

	element;

	/** @type Section[] */
	sections;

	sidebarButtons;

	constructor(element)
	{
		let self = $(element);
		this.element = element;
		this.sections = {};
		this.sidebarButtons = {};
		this.enumerateElements();

		self.data('SplitPane', self.data('SplitPane') || this);
		SplitPane.main = SplitPane.main || this;
	}

	static enumerate()
	{
		$('.x-split-pane').each((i, self) =>
		{
			(new SplitPane(self));
		});
	}

	static get()
	{
		this.enumerate();
		return this.main;
	}

	enumerateElements()
	{
		this.sections = {};
		this.sidebarButtons = {};

		Section.enumerate();

		// noinspection JSCheckFunctionSignatures
		this.sections = $(this.element).find('.x-section').get().mapToObject((elem, i) =>
	    {
		    let section = $(elem).data('Section');
		    return section && section.key ? { [section.key]: section } : {};
	    });
	}
}

window.SplitPane = SplitPane;

$(SplitPane.enumerate);
